// Toast notification system for Banner Baker
// Renders flash messages as Fluent-style toasts in the bottom-right corner

const SUCCESS_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
</svg>`;

const ERROR_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
</svg>`;

const CLOSE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
  <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
</svg>`;

let toastId = 0;

function createToastElement(message, type, role) {
  const id = `toast-${++toastId}`;
  const isType = type === 'success' ? 'lot-toast-success' : 'lot-toast-error';
  const icon = type === 'success' ? SUCCESS_ICON : ERROR_ICON;

  const toast = document.createElement('div');
  toast.id = id;
  toast.className = `lot-toast ${isType}`;
  toast.setAttribute('role', role);
  toast.setAttribute('aria-live', 'assertive');

  toast.innerHTML = `
    <div class="lot-toast-icon" aria-hidden="true">${icon}</div>
    <div class="lot-toast-content">
      <p class="lot-toast-message">${message}</p>
    </div>
    <button type="button" class="lot-toast-close" aria-label="Close notification">
      ${CLOSE_ICON}
    </button>
  `;

  const closeBtn = toast.querySelector('.lot-toast-close');
  closeBtn.addEventListener('click', () => dismissToast(toast, id));

  return toast;
}

function dismissToast(toast, id) {
  if (toast.classList.contains('lot-toast-out')) return;
  toast.classList.add('lot-toast-out');
  setTimeout(() => {
    const container = document.getElementById('toast-container');
    if (container && container.contains(toast)) {
      container.removeChild(toast);
    }
  }, 200);
}

export function showToast(message, type = 'success', options = {}) {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const role = type === 'success' ? 'status' : 'alert';
  const duration = options.duration || 5000;

  const toast = createToastElement(message, type, role);
  container.appendChild(toast);

  if (duration > 0) {
    setTimeout(() => dismissToast(toast, toast.id), duration);
  }
}

export function initFlashToasts() {
  const body = document.body;
  const notice = body.dataset.flashNotice || '';
  const alert = body.dataset.flashAlert || '';

  if (notice) {
    showToast(notice, 'success', { duration: 5000 });
  }
  if (alert) {
    showToast(alert, 'error', { duration: 5000 });
  }
}
